import axios from "axios";

// When the server says the login has expired (it also removes the old cookie), tell the rest of the site, so it can
// switch to guest mode and ask the player to log in again instead of half working.
export const LOGIN_EXPIRED_EVENT = "login-expired";

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401 && error.response.data?.loginExpired) {
            window.dispatchEvent(new Event(LOGIN_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);
